<div class="min-h-screen">
  <div class="min-h-screen flex justify-center">
    <div class="w-full mx-auto">
      <div class="flex flex-row w-full" *ngFor="let event of timeline">
        <div class="w-2/3 px-2 py-10">
          <div class="flex flex-col w-full rounded-lg shadow bg-gray-100 px-4 py-5">
            <div class="text-gray-600 mb-2 flex justify-between">
              <div class="italic" [innerHTML]="event.description"></div>
            </div>
            <div *ngIf="event.image" class="p-1 mt-1">
              <img src="{{ event.image }}" alt="Afbeelding" class="shadow h-64 rounded" />
            </div>
          </div>
        </div>

        <div class="w-1/3  flex justify-center">
          <div class="relative flex h-full w-1 bg-gray-600 items-center justify-center">
            <div class="absolute flex flex-col justify-center h-24 w-24 rounded-full border-2 border-gray-600 leading-none text-center z-10 bg-white font-thin">
              <span class="font-bold">{{ event.start }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
